module.exports = __webpack_public_path__ + "img/NS-mob.02ecba3c.jpg";